import { gql } from './apollo';

export const CREATE_PROPERTY_PROPERTY_USER = gql`
    mutation (
        $propertyuser: MultiTypeInput
        $property: MultiTypeInput
        $createddate: MultiTypeInput
        $sfid: MultiTypeInput
    ) {
        createRow(
            table: "property_propertyuser__c"
            values: [
                { property: "propertyuser__c", value: $propertyuser }
                { property: "property__c", value: $property }
                { property: "sfid", value: $sfid }
                { property: "createddate", value: $createddate }
                { property: "systemmodstamp", value: $createddate }
                { property: "isdeleted", value: false }
            ]
        )
    }
`;

export const GET_PROPERTY_PROPERTY_USERS_FOR_USER = gql`
    query ($propertyuser_id: MultiTypeInput!) {
        table(
            name: "property_propertyuser__c"
            filter: [{ left: "propertyuser__c", right: $propertyuser_id, expression: "=" }]
            limit: 50
        )
    }
`;

export const UPDATE_PROPERTY_PROPERTY_USER_IS_DELETED = gql`
    mutation ($id: String!, $date: MultiTypeInput!, $isdeleted: MultiTypeInput!) {
        updateRow(
            table: "property_propertyuser__c"
            id: $id
            values: [
                { property: "isdeleted", value: $isdeleted }
                { property: "systemmodstamp", value: $date }
            ]
        )
    }
`;

export const HARD_DELETE_PROPERTY_PROPERTY_USER = gql`
    mutation ($id: String!) {
        deleteRow(table: "property_propertyuser__c", id: $id)
    }
`;
